module.exports = __webpack_public_path__ + "static/blog7-bf1523451f03e276fdd4b7c6d7af07b4.png";